module.exports = __webpack_public_path__ + "static/img/tab_item1_no.a4372947.png";